var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnavailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.665 6.335a.988.988 0 00-1.403 0L10 8.607 7.738 6.335a.992.992 0 00-1.403 1.403L8.607 10l-2.272 2.262a.987.987 0 000 1.403.988.988 0 001.403 0L10 11.393l2.262 2.272a.988.988 0 001.403 0 .989.989 0 000-1.403L11.393 10l2.272-2.262a.988.988 0 000-1.403zm3.32-3.32a9.878 9.878 0 10-13.97 13.97 9.878 9.878 0 1013.97-13.97zM15.59 15.592A7.903 7.903 0 1117.903 10a7.854 7.854 0 01-2.312 5.591z",
    fill: "#444"
  })));
}
export default SvgUnavailable;